/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom, Subject} from 'rxjs';
import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './retail-product-creatives-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {CreativeApiService} from '../creative/creative-api.service';
import {LayoutApiService} from '../admin/layout/layout-api.service';

export interface RetailProductCreativesModalResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-retail-product-creatives-modal',
  template
})
export class RetailProductCreativesModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  bulkSelection: any[] = [];

  readonly onCreated = new Subject<RetailProductCreativesModalResult>();

  lineItem: any = {};
  destination = true;
  refLayout: any;
  validationErrors: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeApiService) private readonly Creative: CreativeApiService,
    @Inject(LayoutApiService) private readonly Layout: LayoutApiService,
    private readonly ngZone: NgZone,
    private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()
  ) {
  }

  ngOnInit(): void {
    firstValueFrom(this.Layout.listOptions()).then((page: any) => {
      this.ngZone.run(() => {
        _.forEach(page.results, (layout: any) => {
          if (layout.detectedCategory === 'RETAIL') {
            this.refLayout = layout;
          }
        });
      });
    });
  }

  createRetailCreatives(): void {
    if (!this.refLayout?.id) {
      return;
    }

    const allPromises: any[] = [];
    const merchantGuide = this.localNetworkInfo.getMerchantGuide();
    _.forEach(this.bulkSelection, (rp: any) => {
      const merchantLink = merchantGuide[rp.merchantId].link;
      allPromises.push(firstValueFrom(this.Creative.retailAd(_.get(this, ['lineItem', 'id']), '', this.refLayout.id, merchantLink, rp.itemId)));
    });
    Promise.all(allPromises).then(() => {
      this.ngZone.run(() => {
        this.onCreated.next({model: this.lineItem, destination: this.destination});
        this.bsModalRef.hide();
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
